const dataAbout = [
    {
        id: 1,
        title: 'Character-led art',
        desc: 'Every Chimp is assembled from bold pirate-inspired traits, designed to feel collectible at thumbnail size and expressive up close.',
        class: 'active'
    },
    {
        id: 2,
        title: '232 traits, 31 categories',
        desc: 'A deep trait system gives the collection range, rarity, and the kind of tiny visual surprises collectors love to hunt for.',
        class: 'active'    
    },

    {
        id: 3,
        title: 'Made for the crew',
        desc: 'The project is being shaped around long-term collectors, builders, artists, and Bitcoin-native culture rather than short-lived hype.',
        class: 'active'
    },
]

export default dataAbout;
